import { render, staticRenderFns } from "./ordersOverviewPage.vue?vue&type=template&id=1abd5ff0&"
import script from "./ordersOverviewPage.vue?vue&type=script&lang=ts&"
export * from "./ordersOverviewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports